import { css } from '@eti/styles';
import { ReactComponent as ExitLeft } from '@eti/assets/icons/exit-left.svg';
import { ReactComponent as ExitRight } from '@eti/assets/icons/exit-right.svg';
import React from 'react';
import { vars } from '@etg/wings';
import { jsx as _jsx } from "react/jsx-runtime";
const ArrowDirection = {
  LEFT: 'left',
  RIGHT: 'right'
};
const wrapperStyles = direction => css`
  align-items: center;
  display: flex;
  height: 22px;
  justify-content: center;
  margin-bottom: 0;
  margin-top: 0;
  position: relative;
  width: 32px;

  svg {
    fill: ${vars.colors.signal.critical.foreground};
    height: 24px;
    position: absolute;
    width: 24px;
    ${direction}: 0;
  }
`;
const ExitArrow = _ref => {
  let {
    direction
  } = _ref;
  const Icon = direction === ArrowDirection.LEFT ? ExitLeft : ExitRight;
  return /*#__PURE__*/_jsx("div", {
    className: wrapperStyles(direction),
    children: /*#__PURE__*/_jsx(Icon, {})
  });
};
ExitArrow.Direction = ArrowDirection;
export default ExitArrow;
//# sourceMappingURL=ExitArrow.js.map